module.exports = __webpack_public_path__ + "static/media/fabrica.479a8b8a.svg";